
export const roomTypesColumns = [
    {
    Header: "NAME",
    accessor: "first_name",
    },
    {
        Header: "ROOM TYPE",
        accessor: "room_type",
    },
    {
        Header: "ROOM NUMBER",
        accessor: "room_number",
    },
    {
        Header: "CHECK IN",
        accessor: "check_in",
    },
    {
        Header: "CHECK OUT",
        accessor: "check_out",
    },
    {
        Header: "TOTAL AMOUNT",
        accessor: "total_amount",
    },
    
    {
        Header: "STATUS",
        accessor: "status",
    },
    {
        Header: "Action",
        accessor: "reservationList",
        disableSortBy: true,
    },
    
];
